import type { VariantCombination } from "../types";
import { availabilityRank } from "./availabilityRank";

export function compareCombinations(
  a: Pick<VariantCombination, "stock" | "sellingPrice" | "name">,
  b: Pick<VariantCombination, "stock" | "sellingPrice" | "name">,
  locale: string,
) {
  const stock = availabilityRank(a.stock) - availabilityRank(b.stock);
  if (stock !== 0) return stock;
  const price = a.sellingPrice - b.sellingPrice;
  if (price !== 0) return price;
  return a.name.localeCompare(b.name, locale);
}
